import { render, staticRenderFns } from "./WorkLoadType.vue?vue&type=template&id=69a6845b"
import script from "./WorkLoadType.vue?vue&type=script&lang=js"
export * from "./WorkLoadType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a6845b')) {
      api.createRecord('69a6845b', component.options)
    } else {
      api.reload('69a6845b', component.options)
    }
    module.hot.accept("./WorkLoadType.vue?vue&type=template&id=69a6845b", function () {
      api.rerender('69a6845b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/WorkLoadType.vue"
export default component.exports